import { render, staticRenderFns } from "./Dispute.vue?vue&type=template&id=386dfd0b&"
import script from "./Dispute.vue?vue&type=script&lang=js&"
export * from "./Dispute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports